import { NgModule, Optional, SkipSelf } from '@angular/core';

import { APP_SERVICES } from './services';
import { APP_CONFIG, appConfig } from './config';

@NgModule({
  providers: [
    APP_SERVICES,
    {
      provide: APP_CONFIG,
      useValue: appConfig
    }
  ]
})

export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
          'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}